import { isValueObjectType } from '../../../utils/common'

// The post profile response exposes the author as the `owner_obj` user object,
// while `created_by`/`updated_by` are bare numeric ids. The user item throws
// on `'avatarColor' in <id>`, so only pass through actual user objects.
export function getWidgetUser(value) {
  return isValueObjectType(value) ? value : null
}
